import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ContratAEditerDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAEditerDto";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";

export class ModalSalariesOptions {
	public title?: string = "Choisir un ou plusieurs contrats"
	public callBackYes?: Function = undefined;
	public callBackNo?: Function = undefined;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public anneeDebut: number = 0;
	public anneeFin: number = 0;
	public moisDebut: number = 0;
	public moisFin: number = 0;
	public salaries: ContratAEditerDto[] = [];

	public constructor(init?: Partial<ModalSalariesOptions>) {
		(<any>Object).assign(this, init);
	}
}

@Component
export default class ModalSalaries extends Vue {
	public title?: string = "Choisir un ou plusieurs contrats"
	public callBackYes?: Function;
	public callBackNo?: Function;
	public yesText?: string = "VALIDER";
	public noText?: string = "ANNULER";
	public anneeDebut: number = 0;
	public anneeFin: number = 0;
	public moisDebut: number = 0;
	public moisFin: number = 0;
	public dataReady = false;
	public salaries: ContratAEditerDto[] = [];
	public demande?: DemandeEditionTableauDto;
	public allSelected = false;

	public init(options: ModalSalariesOptions): void {
		this.title = options.title;
		this.callBackYes = options.callBackYes;
		this.callBackNo = options.callBackNo;
		this.yesText = options.yesText;
		this.noText = options.noText;
		this.anneeDebut = options.anneeDebut;
		this.moisDebut = options.moisDebut;
		this.anneeFin = options.anneeFin;
		this.moisFin = options.moisFin;
		this.salaries = options.salaries;
		this.allSelected = false;
		this.$forceUpdate();

		this.dataReady = true;
		$("#modalSalaries").modal("show");
	}

	public valider(): void {
		var listIdContrat: number[] = [];
		for (let i = 0; i < this.salaries.length; i++) {
			const salarie: any = this.salaries[i];
			if (salarie.selected) {
				listIdContrat.push(this.salaries[i].IdContrat as number);
			}
		}

		if (this.callBackYes != undefined) {
			this.callBackYes(listIdContrat);
		}
		this.closeModal();
	}

	public closeModal(): void {
		$("#modalSalaries").modal("hide");
	}

	public annuler(): void {
		if (this.callBackNo != undefined) {
			this.callBackNo();
		}
		this.closeModal();
	}

	public checkAll() {
		for (let i = 0; i < this.salaries.length; i++) {
			const c: any = this.salaries[i];
			c.selected = this.allSelected;
		}
		this.$forceUpdate();
	}

	public clickCheck(target: any): void {
		const element: HTMLElement = document.getElementById(target) as HTMLElement;
		element.click();
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalSalaries/modalSalaries.ts